<template>
  <el-card>
    <div>
      <!-- 标签管理 -->
      <!--      标签管理-->
      <el-row type="flex" justify="end">
        <el-input style="width:150px" aria-placeholder="标签" v-model="title"></el-input>
        <el-button @click="searchthis()">搜索</el-button>
        <el-button type="primary" @click="dialogFormVisible = true">添加人物</el-button>
        <el-dialog title="添加人物" :visible.sync="dialogFormVisible">
          <el-form :model="addperson">
            <el-form-item label="姓名" :label-width="formLabelWidth">
              <el-input autocomplete="off" v-model="addperson.name"></el-input>
            </el-form-item>
            <el-form-item label="排序" :label-width="formLabelWidth">
              <el-input autocomplete="off" v-model="addperson.orderId" @input="changetonum"></el-input>
            </el-form-item>
            <el-form-item label="隶属机构" :label-width="formLabelWidth">
              <el-cascader
                style="width:35%;"
                :options="parentlist"
                :props="{multiple: false,value:'value',label:'label'}"
                v-model="thisorglist"
                @change="changeOrgId"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="subform('addform')">确 定</el-button>
          </div>
        </el-dialog>
      </el-row>
      <el-table
        :data="tableData"
        row-key="id"
        default-expand-all
        :tree-props="{children: 'list', hasChildren: 'hasChildren'}"
        style="width: 100%"
      >
        <el-table-column prop="orderId" label="排序"></el-table-column>
        <el-table-column fixed="right" label="姓名">
          <template slot-scope="scope">
            <span
              v-if="scope.row.orgId==undefined"
              style="color: deepskyblue;font-size:16px"
            >{{scope.row.name}}</span>
            <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.orgId!=undefined"
              @click="editthis(scope.row)"
              size="small"
            >编辑</el-button>
            <el-button
              type="text"
              v-if="scope.row.orgId!=undefined"
              @click="deletethis(scope.row)"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      thisorglist: [],
      title: "",
      tableData: [],
      parentlist: [{}],
      addperson: {
        id: "",
        orderId: "",
        name: "",
        orgId: ""
      },
      dialogFormVisible: false,
      formLabelWidth: "120px"
    };
  },
  methods: {
    // 去除空数组
    treeData: function(data) {
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length === 0) {
          data[i].children = null;
        } else {
          this.treeData(data[i].children);
        }
      }
      return data;
    },
    getTableDate: async function() {
      var res = await this.$http.get(
        `/v1/videoPerson/personList?title=${this.title}`
      );
      var { data, message, code } = res.data;
      if (code == 0) {
        this.tableData = data;
      }
    },
    deletethis: function(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(
            `/v1/videoPerson/personDelete?id=${id}`
          );
          var { data, message, code } = res.data;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getTableDate();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    editthis: async function(row) {
      //编辑
      this.addperson.id = row.id;
      this.addperson.orderId = row.orderId;
      this.addperson.name = row.name;
      this.addperson.orgId = row.orgId;
      this.dialogFormVisible = true;
    },
    subform: async function() {
      var res = await this.$http.post(
        `/v1/videoPerson/personSaveOrUpdate`,
        this.addperson
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$message.success("添加/编辑成功");
        this.dialogFormVisible = false;
        this.getTableDate();
        this.addperson.id = "";
        this.addperson.orgId = "";
        this.addperson.name = "";
      } else {
        this.$message.error(message);
      }
    },
    /*  getOneCom:async function () {
        var res=await this.$http.get(
          `/v1/organization/organizationOneList?id=1`
        )
        var {data,message,code}= res.data;
        if(code==0){
          this.parentlist = data;
        }
      },*/
    getOrganizationList: async function() {
      var res = await this.$http.get(`/v1/index/organizationList`);
      var { code, data, message } = res.data;
      if (code == 0) {
        this.parentlist = this.treeData(data);
        this.parentlist.push({
          label: "隶属机构未知",
          value: "hjdwsuig",
          children: [
            {
              label: "隶属机构未知",
              value: -1
            }
          ]
        });
      }
    },
    searchthis: function() {
      this.page == 1;
      this.getTableDate();
    },
    changeOrgId: function(value) {
      this.addperson.orgId = value[1];
    },
    changetonum: function() {
      var res = this.addperson.orderId;
      this.addperson.orderId = res.replace(/[^\d]/g, "");
      /* addperson.orderId=value.replace(/[^\d]/g,'')"*/
    }
  },
  mounted() {
    this.getTableDate();
    this.getOrganizationList();
  },
  watch: {
    tableData: {
      handler(newName, oldName) {
        if (this.total == (this.page - 1) * this.limit && this.total != 0) {
          //这一行是关键代码，倍数关系
          this.page -= 1;
          this.getTableDate(); //获取表格数据的方法
        }
      },
      // tableData() {  //注意这个函数的名字必须和你监听data中的属性的名字一样，这样才能当你data中的属性发生变化时，触发这个函数
      //   if (this.total == (this.currentPage - 1) * this.pageSize && this.total != 0) { //这一行是关键代码，倍数关系
      //     this.currentPage -= 1
      //     this.getTagData()//获取表格数据的方法
      //   }
      // },
      deep: true
    },
    dialogFormVisible: {
      handler: function(newName, oldName) {
        if (newName == false) {
          this.addperson.id = "";
          this.addperson.name = "";
          this.addperson.orderId = "";
          this.addperson.orgId = "";
          this.thisorglist = [];
        }
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/comAndPerson-mg/searchPerson.vue